import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ManagersServiceProvider } from '../../api/managers'

const ManagersService = ManagersServiceProvider()
const name = 'managerAssignEmployees'

export default (managerId, employeeIds, alternativeCampaignName) => {
  const data = { managerId, employeeIds }
  if (alternativeCampaignName) {
    data.alternativeCampaignName = alternativeCampaignName
  }
  return asyncAction(
    name,
    ManagersService.assignEmployees,
    data
  )
}

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/manager/managerAssignEmployees.js